

//
export const _novo_tabela_za_ramfiltera = [
  {
    "Šifra": "B000100000000031",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 305x305x25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000032",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 305x610x25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000033",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 610x610x25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000034",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 510x610x25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000035",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 510x305x25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000041",
    "Naziv": "FILTERI OPREMA RAM PROHROM 305x305x25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000042",
    "Naziv": "FILTERI OPREMA RAM PROHROM 305x610x25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000043",
    "Naziv": "FILTERI OPREMA RAM PROHROM 610x610x25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000044",
    "Naziv": "FILTERI OPREMA RAM PROHROM 510x610x25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000045",
    "Naziv": "FILTERI OPREMA RAM PROHROM 510x305x25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000036",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 305x305x45 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000037",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 305x610x45 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000038",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 610x610x45 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000039",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 510x610x45 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000040",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 510x305x45 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000046",
    "Naziv": "FILTERI OPREMA RAM PROHROM 305x305x45 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000047",
    "Naziv": "FILTERI OPREMA RAM PROHROM 305x610x45 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000048",
    "Naziv": "FILTERI OPREMA RAM PROHROM 610x610x45 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000049",
    "Naziv": "FILTERI OPREMA RAM PROHROM 510x610x45 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000050",
    "Naziv": "FILTERI OPREMA RAM PROHROM 510x305x45 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  /*
  {
    "Šifra": "B000100000000051",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 305x305x96 TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000052",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 305x610x96 TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000053",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 610x610x96 TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000054",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 510x610x96 TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000055",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 510x305x96 TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000056",
    "Naziv": "FILTERI OPREMA RAM PROHROM 305x305x96 TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000057",
    "Naziv": "FILTERI OPREMA RAM PROHROM 305x610x96 TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000058",
    "Naziv": "FILTERI OPREMA RAM PROHROM 610x610x96 TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000059",
    "Naziv": "FILTERI OPREMA RAM PROHROM 510x610x96 TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000060",
    "Naziv": "FILTERI OPREMA RAM PROHROM 510x305x96 TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000061",
    "Naziv": "FILTERI OPREMA RAM PROHROM 305x610x300 TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000062",
    "Naziv": "FILTERI OPREMA RAM PROHROM 610x610x300 TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000063",
    "Naziv": "FILTERI OPREMA RAM PROHROM 610x508x300 TERMOVENT",
    "Materijal": "PROHROM"
  },
  */
  {
    "Šifra": "B000100000000115",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 305x305x45-25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000116",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 305x610x45-25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000117",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 610x610x45-25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000118",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 510x610x45-25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000119",
    "Naziv": "FILTERI OPREMA RAM POCINKOVANI 510x305x45-25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
  {
    "Šifra": "B000100000000110",
    "Naziv": "FILTERI OPREMA RAM PROHROM 305x305x45-25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000111",
    "Naziv": "FILTERI OPREMA RAM PROHROM 305x610x45-25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000112",
    "Naziv": "FILTERI OPREMA RAM PROHROM 610x610x45-25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000113",
    "Naziv": "FILTERI OPREMA RAM PROHROM 510x610x45-25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000114",
    "Naziv": "FILTERI OPREMA RAM PROHROM 510x305x45-25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000105",
    "Naziv": "FILTERI OPREMA RAM PROHROM HEPPA 305x305x25 P111-A TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000106",
    "Naziv": "FILTERI OPREMA RAM PROHROM HEPPA 510x305x25 P111-A TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000107",
    "Naziv": "FILTERI OPREMA RAM PROHROM HEPPA 305x610x25 P111-A TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000108",
    "Naziv": "FILTERI OPREMA RAM PROHROM HEPPA 510x610x25 P111-A TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000109",
    "Naziv": "FILTERI OPREMA RAM PROHROM HEPPA 610x610x25 P111-A TERMOVENT",
    "Materijal": "PROHROM"
  },

  {
    "Šifra": "B000100000000365",
    "Naziv": "FILTERI OPREMA RAM PROHROM HEPPA 305x610x292 P111-C TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000366",
    "Naziv": "FILTERI OPREMA RAM PROHROM HEPPA 610x610x292 P111-C TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000363",
    "Naziv": "FILTERI OPREMA MASKA PROHROM 305x305x25 P111-B TERMOVENT",
    "Materijal": "PROHROM"
  },
  {
    "Šifra": "B000100000000364",
    "Naziv": "FILTERI OPREMA MASKA POCINKOVANI 305x305x25 P111-B TERMOVENT",
    "Materijal": "POCINKOVANI"
  },
];


//
const _izracunaj_dodatne_stringove_za_pretragu = (rfi_tipfiltera) => {
  /*
  VRECASTI FILTER 25mm	75
  PANELNI FILTER 45mm	100
  DUPLI FILTER 24+45mm	125
  HEPA 25mm	82
  HEPA 292mm	150
  CARBON	75
  */
  if (rfi_tipfiltera === "VRECASTI_25") {
    return ['x25', null, 'HEPPA'];
  } else if (rfi_tipfiltera === "PANELNI_45") {
    return ['x45', null, 'HEPPA'];
  } else if (rfi_tipfiltera === "DUPLI_24_45") {
    return ['x45-25', null, 'HEPPA'];
  } else if (rfi_tipfiltera === "HEPA_25") {
    return ['HEPPA', 'x25', null];
  } else if (rfi_tipfiltera === "HEPA_292") {
    return ['HEPPA', 'x292', null];
  } else if (rfi_tipfiltera === "CARBON") {
    return [null, null, 'HEPPA'];
  }
  return [null, null];
};


//
export const _novo_tabela_za_ramfiltera_get_item = (tipkomore, rfi_tipfiltera, q, q2, excl1, excl2) => {
  //
  let _item = {};
  let _ter_filter = {};
  let tipmetalalima = "pocinkovani";
  if (tipkomore === "HYGIENE:pro" || rfi_tipfiltera === "HEPA_25" || rfi_tipfiltera === "HEPA_292") {
    tipmetalalima = "prohrom";
  } else {
    tipmetalalima = "pocinkovani";
  }
  //
  let [q31, q32, excl31] = _izracunaj_dodatne_stringove_za_pretragu(rfi_tipfiltera);
  if (q === 'MASKA') {
    q31 = null;
    q32 = 'x25';
  }
  //
  _novo_tabela_za_ramfiltera.forEach((item) => {
    if (item && typeof item["Materijal"] === 'string' && tipmetalalima && item["Materijal"].toUpperCase() === tipmetalalima.toUpperCase() && typeof item["Naziv"] === 'string' && item["Naziv"].includes(q) && ((typeof q2 === 'string' && item["Naziv"].includes(q2)) || !q2) && ((typeof q31 === 'string' && item["Naziv"].includes(q31)) || !q31) && ((typeof q32 === 'string' && item["Naziv"].includes(q32)) || !q32)) { // if include
      if ((!excl1 || typeof excl1 === 'string' && !item["Naziv"].includes(excl1)) && (!excl2 || typeof excl2 === 'string' && !item["Naziv"].includes(excl2)) && (!excl31 || typeof excl31 === 'string' && !item["Naziv"].includes(excl31))) { // and if not include
        _item = item;
      }
    }
  });
  //
  _ter_filter.identcustom = _item["Šifra"];
  _ter_filter.naziv = _item["Naziv"];
  return _ter_filter;
};
/*
{
  "Šifra": "B000100000000031",
  "Naziv": "FILTERI OPREMA RAM POCINKOVANI 305x305x25 P111-B TERMOVENT",
  "Materijal": "POCINKOVANI"
},
*/

